// extracted by mini-css-extract-plugin
var _1 = "src-components-common-Modal-module__full";
var _2 = "src-components-common-Modal-module__wide";
export { _1 as "full", _2 as "wide" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"full\":\"src-components-common-Modal-module__full\",\"wide\":\"src-components-common-Modal-module__wide\"}";
        // 1777708299448
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  